import {BaseModelMicroService} from './base-model-micro-service';
import {Customer} from './customer';

export class CustomerRef extends BaseModelMicroService {
    name: string;
    code: string;
    address: string;
}